export interface DefaultToneDto
{
   
    getClientTxnId(): string;
    getAPartyMsisdn(): string;
    getLanguage(): string;
    getToneId(): string;
    getPriority():string;
    getChannelId():string;
    getServiceId():string;
    getPackName():string;
}

export class DefaultToneDtoImpl 
{
    
    private aPartyMsisdn: string;
    private clientTaxnId: string;
    private language: string;
    private toneId: string;
    private priority: string;
    private channelId: string;
    private packName: string;
    private serviceId: string;

    
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    } 
    setClientTaxnId(clientTaxnId: string)
    {
        this.clientTaxnId = clientTaxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTaxnId;
    } 
    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

  

    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }
    getToneId(): string 
    {
        return this.toneId;
    } 

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string 
    {
        return this.priority;
    } 
    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 
    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string 
    {
        return this.serviceId;
    }
    setPackName(packName: string)
    {
        this.packName = packName;
    }
    getPackName(): string 
    {
        return this.packName;
    }  
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/deafulttone/defaulttonedto.ts